import { render } from "./ElDialog.vue?vue&type=template&id=39851bb2&scoped=true&ts=true"
import script from "./ElDialog.vue?vue&type=script&lang=ts"
export * from "./ElDialog.vue?vue&type=script&lang=ts"

import "./ElDialog.vue?vue&type=style&index=0&id=39851bb2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39851bb2"]])

export default __exports__